export default __webpack_public_path__ + "static/media/youtube.a9142e80.svg";